import './_jquery';
import 'waypoints/lib/jquery.waypoints.js';

const fixBreadcrumb = function(status) {
  let $breadcrumb, menu, menuHeight, menuTransitionDelay;
  $breadcrumb = $('.breadcrumb');
  menu = document.querySelector('.site-header__components');

  if (menu === null) {
    return;
  }

  menuHeight = function() {
    return menu.offsetHeight || 0;
  };

  // Il menu ha una transition quindi quanto viene modificato in altezza ci mette
  // un tot a renderizzarsi all'altezza di destinazione. In questo modo malato
  // mi sto leggendo il timing della transizione su di esso, espressa in secondi
  // e la convero in millisecondi.
  // ATTENZIONE: in css il timing è espresso con una stringa e.g.: "0.3s" da cui
  // devo rimuovere l'unità di misura per fare i calcoli
  // ATTENZIONE: ovviamente se cambia il CSS questa cosa non funziona. io metto un
  // fallback a 100 millisecondi che non dovrebbe mai guastare
  menuTransitionDelay = parseFloat(window.getComputedStyle(menu).getPropertyValue('transition-duration').slice(0, -1)) * 1000 || 100;

  if (status === 'fix') {
    if (!$breadcrumb.hasClass('breadcrumb--fixed')) {
      setTimeout(function() {
        $breadcrumb.attr('style', 'top: ' + menuHeight() + 'px');
        return $breadcrumb.addClass('breadcrumb--fixed');
      }, menuTransitionDelay); // Devo ricalcolare l'altezza solo dopo che il rendering, incluso di
                               // transition, è terminato
    }
  }

  if (status === 'unfix') {
    if ($breadcrumb.hasClass('breadcrumb--fixed')) {
      $breadcrumb.removeClass('breadcrumb--fixed');
    }
    $breadcrumb.removeAttr('style');
  }

  return typeof Waypoint !== "undefined" && Waypoint !== null ? Waypoint.refreshAll() : void 0;
};

jQuery(function() {
  let menuHeight, prevScroll, scroll;

  if ($('[data-page]').data('page') !== 'deepening') {
    prevScroll = scroll = $(window).scrollTop();
    menuHeight = function() {
      let ref;
      return ((ref = document.querySelector('.site-header__components')) != null ? ref.offsetHeight : void 0) || 0;
    };

    $(window).on('load', function() {
      if (window.pageYOffset > (menuHeight() + 50)) {
        return fixBreadcrumb('fix');
      } else {
        return fixBreadcrumb('unfix');
      }
    });

    $(window).scroll(function() {
      prevScroll = scroll;
      scroll = $(window).scrollTop();
      if ($.isNumeric(menuHeight())) {
        if (scroll > prevScroll && (scroll > menuHeight() && prevScroll <= menuHeight())) {
          fixBreadcrumb('fix');
        }
        if (scroll < prevScroll && (scroll <= menuHeight() && prevScroll > menuHeight())) {
          fixBreadcrumb('unfix');
        }
      }
    });
  }
});
